import React, { useEffect, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchData } from "../states/actions/factAndStats";
import Footer from "../components/shared/Footer";
import Header from "../components/shared/Header";
import LoadingScreen from "../components/LoadingScreen";
import { Link, NavLink } from "react-router-dom";
import ImageControl from "../components/ImageControl";
import useDocumentTitle from "../hooks/useDocumentTitle";
import Text from "../components/Text";
import { getBackgroundImageUrl, newsDateFormat } from "../helpers/helpers";
import useScrollTop from "../hooks/useScrollTop";

const FactAndStatsContainer = () => {
  const data = useSelector((state) => state.factAndStats.content);
  const isLoading = useSelector((state) => state.factAndStats.isLoading);
  const dispatch = useDispatch();
  const { content, site_settings, news } = data;

  useEffect(() => {
    dispatch(fetchData());
  }, []);
  useEffect(() => {
    document.body.classList.remove('liveTvBody');
  }, []);
  useDocumentTitle(data.page_title);
  useScrollTop();

  return (
    <>
      <LoadingScreen isLoading={isLoading} />
      {!isLoading && (
        <div>
          <Header siteSettings={site_settings} />
          <main className="index">
            <div className="mini-label">
              <div className="contain">
                <ul>
                  <li>
                    <Link to="/what-is-human-trafficking">
                      About Sex &amp; Trafficking
                    </Link>
                  </li>
                  <li>
                    <Link to="/fact-and-statistics">FACTS, AND STATISTICS</Link>
                  </li>
                </ul>
              </div>
            </div>
            <section
              className="sub-banner fact-page"
              style={{
                backgroundImage: `url(${getBackgroundImageUrl(content.image1)})`
              }}
            >
              <div className="contain">
                <div className="cntnt">
                  <h1>
                    <Text string={content.banner_heading} />
                  </h1>
                  <Text string={content.banner_desc} parse={true} />
                </div>
              </div>
            </section>
            {/* banner */}
            <section className="cmn-tabs fact-tab">
              <div className="contain">
                <div className="flex">
                  <div className="colL">
                    <div className="tabs-lst">
                      <ul>
                        <li className="active">
                          <NavLink
                            to="/what-is-human-trafficking"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            What is human trafficking?
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/what-is-sex-trafficking"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            What is Sex trafficking?
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/fact-and-statistics"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            FACTS, AND STATISTICS
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/policy-and-legislation"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            POLICY &amp; LEGISLATION
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                    <div className="side-poster relative">
                      <div className="image">
                        <ImageControl folder="images" src={content.image2} />
                      </div>
                      <div className="cntnt">
                        <div className="immage">
                          <ImageControl folder="images" src={content.image3} />
                        </div>
                        <h2>
                          <Text string={content.sec2_pu_heading} />
                        </h2>
                        <p>
                          <Text string={content.sec2_pu_desc} />
                        </p>
                        <div className="bTn">
                          <Link
                            to={content.sec2_pu_button_link}
                            className="webBtn"
                          >
                            {" "}
                            {content.sec2_pu_button_text}{" "}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="colR">
                    <div className="inner">
                      <Text
                        string={content.sec2_right1_right_desc}
                        parse={true}
                      />
                    </div>
                  </div>
                </div>
                <div className="feature-news">
                  <h4>
                    <Text string={content.last_section_heading} />
                  </h4>
                  <div className="play-list flex">
                    {news.map((nws) => (
                      <div className="col">
                        <div className="inner">
                          <Link to={`/current-affair/news-detail/${nws.id}`} className="image">
                            <ImageControl folder="news" src={nws.image} />
                            <div className="videoBtn fi-play" />
                          </Link>
                          <h5>
                            <Link to={`/current-affair/news-detail/${nws.id}`}>
                              <Text string={nws.heading} />
                            </Link>
                          </h5>
                          <div className="small-category">
                            <span>{newsDateFormat(nws.news_date)}</span>
                            <span>
                              <Text string={nws.video_duration} />
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer siteSettings={site_settings} />
        </div>
      )}
    </>
  );
};

export default FactAndStatsContainer;
